import { createAction, createReducer } from "redux-act";
import { reducerRegistry } from "../reducerRegistry";

const reducerName = "sharedLayers";

type LayerName = string;

export interface SharedLayersState {
  visibleLayers?: LayerName[];
  layersOpacity?: Record<LayerName, number>;
  groupsExpanded?: Record<LayerName, boolean>;
}

const initialState: SharedLayersState = {};

export const reducer = createReducer({}, initialState);

export const setLayerVisible = createAction<LayerName>("shared-layers/set-layer-visible");
export const setLayerInvisible = createAction<LayerName>("shared-layers/set-layer-invisible");
export const setVisibleLayers = createAction<LayerName[]>("shared-layers/set-visible");
export const setLayerOpacity = createAction<{ layerName: LayerName; opacity: number }>("shared-layers/set-opacity");
export const setGroupExpanded = createAction<{ groupName: LayerName; isExpanded: boolean }>(
  "shared-layers/set-expanded",
);

reducer.on(setVisibleLayers, (state, visibleLayers) => ({
  ...state,
  visibleLayers,
}));

reducer.on(setLayerVisible, (state, layerName) => ({
  ...state,
  visibleLayers: state.visibleLayers && [...state.visibleLayers, layerName],
}));

reducer.on(setLayerInvisible, (state, layerName) => ({
  ...state,
  visibleLayers: state.visibleLayers && state.visibleLayers.filter(name => name !== layerName),
}));

reducer.on(setLayerOpacity, (state, { layerName, opacity }) => ({
  ...state,
  layersOpacity: { ...(state.layersOpacity || {}), [layerName]: opacity },
}));

reducer.on(setGroupExpanded, (state, { groupName, isExpanded }) => ({
  ...state,
  groupsExpanded: { ...(state.groupsExpanded || {}), [groupName]: isExpanded },
}));

reducerRegistry.register(reducerName, reducer);
